// extracted by mini-css-extract-plugin
module.exports = {"timeTabWrapper":"timeTabWrapper___1WBCm","dayItem":"dayItem___2cs82","active":"active___1qSUp","discount":"discount___230Tv"};